import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";

class ModalComponent extends Component {
  componentWillMount() { }

  constructor(props, context) {
    super(props);
    this.staticStyle = {
      display: "block",
    };

  }

  onModalOutsideClickClose() {
    this.props.modalActions.closeRemoveModal();
  }

  render() {
    return (
      <div>
        <div
          className={(this.props.isOpen ? "modal fade show" : "modal") + " " + this.props.size}
          style={this.props.isOpen ? this.staticStyle : {}}
          role="dialog"
        >
          {this.props.isOpen && !this.props.disableClose &&
            <div className="modal-close">
              <a className="modal-close-btn" role="button" onClick={() => { this.onModalOutsideClickClose() }}>&times;</a>
            </div>
          }
          {this.props.children}

          {this.props.isOpen && <div className="modal-backdrop show"></div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: state.modalReducer.isOpen,
    children: state.modalReducer.children,
    size: state.modalReducer.size,
    disableClose: state.modalReducer.disableClose,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modalActions: bindActionCreators(modalActions, dispatch),
  };
};

ModalComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent);
